import { ProductCompareCarouselStyles } from "@insite/content-library/Widgets/ProductCompare/ProductCompareCarousel";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

ProductCompareCarouselStyles.carouselGridItem = {
    width: 12,
    css: css`
        > div[data-test-selector^="productCompareCarousel_gridContainer"] {
            background: rgb(238, 238, 239);
            padding: 20px 10px;
            > div[class^="GridOffset"] {
                > div:first-child[class^="GridItemStyle"] {
                    align-items: flex-start;
                    -webkit-box-pack: start;
                    justify-content: flex-start;
                    > button[data-test-selector^="prevBtn"] {
                        transform: translateY(180px);
                        height: 300px;
                    }
                }
                > div[class^="GridItemStyle"] {
                    &:nth-child(2) {
                        > div[class^="GridWrapper"] {
                            > div[class^="GridOffset"] {
                                > div[class^="GridItemStyle"] {
                                    &:nth-child(3) {
                                        padding-top: 20px;
                                        z-index: 1;
                                        > div[class^="GridWrapper"] {
                                            box-shadow: none;
                                            > div[class^="GridOffset"] {
                                                > div:first-child {
                                                    border-top: 1px solid rgb(209, 211, 212);
                                                    > span {
                                                        font-weight: bold;
                                                    }
                                                }
                                                > div[class^="GridItemStyle"] {
                                                    border-left: 1px solid rgb(209, 211, 212);
                                                    border-bottom: 1px solid rgb(209, 211, 212);
                                                    border-right: 1px solid rgb(209, 211, 212);
                                                    padding: 0.8rem;
                                                    > span {
                                                        font-weight: bold;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                > div[class^="GridItemStyle"] {
                                    &:nth-child(4) {
                                        > div {
                                            border-top: 1px solid rgb(209, 211, 212);
                                            border-right: 1px solid rgb(209, 211, 212);
                                            border-bottom: 1px solid rgb(209, 211, 212);
                                            > div {
                                                > div[data-test-selector^="attribute-value-slides"] {
                                                    > div {
                                                        > div[data-test-selector^="slideAttributesContainer"] {
                                                            border-right: 1px solid rgb(209, 211, 212);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                > div:last-child[class^="GridItemStyle"] {
                    align-items: flex-start;
                    -webkit-box-pack: end;
                    justify-content: flex-end;
                    > button[data-test-selector^="nextBtn"] {
                        transform: translateY(180px);
                        height: 300px;
                    }
                }
            }
        }
    `,
};

ProductCompareCarouselStyles.carousel = {
    carouselWrapper: {
        css: css`
            width: 100%;
            position: relative;
            > div {
                > div[data-test-selector^="slides"] {
                    > div {
                        padding: 10px;
                        > div[data-test-selector^="slideContainer"] {
                            border: 1px solid rgb(213, 213, 213);
                            background: #ffffff;
                            > div[data-test-selector^="productContainer"] {
                                > div[class^="GridOffset"] {
                                    width: 100%;
                                    margin: 0;
                                    > div[class^="GridItemStyle"] {
                                        div[data-test-selector="carousel_slide"] {
                                            height: 250px;
                                        }
                                        > a[data-test-selector^="productImage"] {
                                            height: 146px;
                                            width: 146px;
                                            img {
                                                width: 100%;
                                                height: 100%;
                                                object-fit: contain;
                                                object-position: center top;
                                            }
                                        }
                                        > a[data-test-selector^="productDescriptionLink"] {
                                            > span[class^="TypographyStyle"] {
                                                font-size: 16px;
                                                font-weight: bold;
                                                color: rgb(53, 52, 50);
                                                white-space: nowrap;
                                                overflow: hidden;
                                                text-overflow: ellipsis;
                                                ${({ theme }) => {
                                                    return breakpointMediaQueries(
                                                        theme,
                                                        [
                                                            css`
                                                                font-size: 14px;
                                                            `,
                                                            css`
                                                                font-size: 14px;
                                                            `,
                                                            null,
                                                            css`
                                                                font-size: 14px;
                                                            `,
                                                            null,
                                                        ],
                                                        "minMax",
                                                    );
                                                }}
                                            }
                                        }
                                        [color^="success"] {
                                            background: transparent;
                                            padding: 0;
                                            span[class^="IconWrapper"] {
                                                background: #008061;
                                                border-radius: 50%;
                                                padding: 2px;
                                                height: 16px;
                                                width: 16px;
                                                svg {
                                                    height: 12px;
                                                    width: 12px;
                                                    color: #fff;
                                                }
                                            }
                                            [data-test-selector^="availabilityMessage"] {
                                                font-size: 14px;
                                                margin-top: -5px;
                                            }
                                        }
                                        [color^="danger"] {
                                            background: transparent;
                                            padding: 0;
                                            span[class^="IconWrapper"] {
                                                background: #008061;
                                                border-radius: 50%;
                                                padding: 2px;
                                                height: 16px;
                                                width: 16px;
                                                svg {
                                                    height: 12px;
                                                    width: 12px;
                                                    color: #fff;
                                                }
                                            }
                                            [data-test-selector^="availabilityMessage"] {
                                                font-size: 14px;
                                                margin-top: -5px;
                                            }
                                        }
                                        > div[class^="FormFieldStyle"] {
                                            max-width: 70%;
                                            flex-basis: 70%;
                                            ${({ theme }) => {
                                                return breakpointMediaQueries(
                                                    theme,
                                                    [
                                                        css`
                                                            max-width: 100%;
                                                            flex-basis: 100%;
                                                        `,
                                                        css`
                                                            max-width: 100%;
                                                            flex-basis: 100%;
                                                        `,
                                                        css`
                                                            max-width: 100%;
                                                            flex-basis: 100%;
                                                        `,
                                                        css`
                                                            max-width: 100%;
                                                            flex-basis: 100%;
                                                        `,
                                                        null,
                                                    ],
                                                    "minMax",
                                                );
                                            }}
                                            > label[data-test-selector^="product_unitOfMeasureSelect-label"] {
                                                max-width: 38%;
                                                flex-basis: 38%;
                                                ${({ theme }) => {
                                                    return breakpointMediaQueries(
                                                        theme,
                                                        [
                                                            css`
                                                                max-width: 30%;
                                                                flex-basis: 30%;
                                                            `,
                                                            css`
                                                                max-width: 30%;
                                                                flex-basis: 30%;
                                                            `,
                                                            css`
                                                                max-width: 40%;
                                                                flex-basis: 40%;
                                                            `,
                                                            css`
                                                                max-width: 30%;
                                                                flex-basis: 30%;
                                                            `,
                                                            null,
                                                        ],
                                                        "minMax",
                                                    );
                                                }}
                                            }
                                            > label[data-test-selector^="product_qtyOrdered-label"] {
                                                max-width: 38%;
                                                flex-basis: 38%;
                                                ${({ theme }) => {
                                                    return breakpointMediaQueries(
                                                        theme,
                                                        [
                                                            css`
                                                                max-width: 30%;
                                                                flex-basis: 30%;
                                                            `,
                                                            css`
                                                                max-width: 30%;
                                                                flex-basis: 30%;
                                                            `,
                                                            css`
                                                                max-width: 40%;
                                                                flex-basis: 40%;
                                                            `,
                                                            css`
                                                                max-width: 30%;
                                                                flex-basis: 30%;
                                                            `,
                                                            null,
                                                        ],
                                                        "minMax",
                                                    );
                                                }}
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
};
